import { SubviewsRecord } from 'sfportal_components_generic/Subviews'

export function useGetProjectProductTreeListSubviews (): () => SubviewsRecord {
  return () => ({})
}
